import type { RouteObject } from 'react-router-dom'
import attendanceRoute from './attendance.route'
import calendarRoute from './calendar.route'
import candidatesRoute from './candidates.route'
import chatRoute from './chat.route'
import cmsRoute from './cms.route'
import dashboardRoute from './dashboard.route'
import demographyRoute from './demography.route'
import employeesRoute from './employees.route'
import exploreRoute from './explore.route'
import jobRoute from './job.route'
import leaveRoute from './leave.route'
import masterDataRoute from './master-data.route'
import masterReportRoute from './master-report.route'
import overtimeRoute from './overtime.route'
import payrollRoute from './payroll.route'
import processRoute from './process.route'
import reimbursementRoute from './reimbursement.route'
import reportRoute from './report.route'
import securityRoute from './security.route'
import settingsRoute from './settings.route'

const mainRoutes: RouteObject[] = [
  {
    children: [
      dashboardRoute,
      jobRoute,
      candidatesRoute,
      settingsRoute,
      employeesRoute,
      processRoute,
      attendanceRoute,
      overtimeRoute,
      leaveRoute,
      payrollRoute,
      cmsRoute,
      masterDataRoute,
      reportRoute,
      calendarRoute,
      chatRoute,
      exploreRoute,
      demographyRoute,
      reimbursementRoute,
      securityRoute,
      masterReportRoute,
    ],
    lazy: () => import('@/layouts/MainLayout'),
  },
]

export default mainRoutes
